
















import Component from 'vue-class-component';
import Vue from 'vue';
import {Prop} from 'vue-property-decorator';
import axios, {AxiosResponse} from 'axios';
import {Toast} from '@/store/toast/toast.types';
import {Action} from 'vuex-class';


@Component({
  components: {

  }
})
export default class UploadFileComponent extends Vue {
  @Prop({default: () => ('' as string)})
  public refID!: string;

  @Prop({default: () => ('' as string)})
  public memberID!: string;

  @Prop({default: () => (false as boolean)})
  public private!: boolean;

  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;

  uuIDV4 = require('uuid/v4');
  public URL_UPLOAD = `${process.env.VUE_APP_API_FILES}asset/register`;
  public refIDCode = '';
  public file = '';


  async mounted() {
    if (this.refID === '' || this.refID == null) {
      this.refIDCode = await this.uuIDV4();
      this.$emit('refIDChanged', this.refIDCode)
    } else {
      this.refIDCode = this.refID;
      this.$emit('refIDChanged', this.refIDCode);
    }
  }



  async onFileChange(e: any) {
    let tmp = e.target.files || e.dataTransfer.files;
    let formData = new FormData();
    await formData.append('file', tmp[0]);
    await formData.append('ownerId', `${this.memberID}`);
    await formData.append('refId', `${this.refIDCode}`);
    await formData.append('primary', 'true');
    await formData.append('private', `${this.private}`);

    let resUpload = await axios.post(this.URL_UPLOAD, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`
      }
    });

    if(resUpload.status === 201) {
      this.Toast({
        heading: 'สำเร็จ',
        message: 'อัพโหลดสำเร็จ',
        type: 'success'
      }).then();
    }else {
      this.Toast({
        heading: 'ไม่สำเร็จ',
        message: 'กรุณาอัพโหลดใหม่อีกครั้ง',
        type: 'danger'
      }).then();
    }
  }


}
